<template>
  <div class="container-fluid">
    <page-header :page="page">
      <template #custom_actions>
        <menu-search v-if="menuAdvanceModeEnabled" v-model="searchQuery" />
      </template>
    </page-header>
    <menu-options
      :advance-mode="menuAdvanceModeEnabled"
      :menu-title="navTitle"
      :search="searchQuery"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader.vue';
import MenuOptions from '@/components/common/menu/MenuOptions';
import MenuSearch from '@/components/common/menu/MenuSearch.vue';
import navMenuTitles from '@/utils/constants/navMenuTitles';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';

export default {
  components: {
    MenuOptions,
    PageHeader,
    MenuSearch,
  },
  data() {
    return {
      menuAdvanceModeEnabled: false,
      page: {
        icon: 'fas fa-book',
        title: 'Becas',
        routes: ['Inicio', 'Becas'],
      },
      navTitle: navMenuTitles.Becas,
      searchQuery: '',
    };
  },
  async created() {
    const { data } = await _getSysparameterByNames({
      parameterNames: ['ProviderMenuAdvanceModeEnabled'],
    });
    this.menuAdvanceModeEnabled =
      data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
  },
};
</script>
